import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { NotificationContext } from "../../context/NotificationContext";
import { NAV_ITEMS } from "./navItems";

const items = NAV_ITEMS.slice(0, 5);

export default function MobileNav() {
  const { categoryCounts } = useContext(NotificationContext);

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 flex border-t border-slate-200 bg-white/95 backdrop-blur lg:hidden">
      {items.map(({ to, label, icon: Icon, notifKey }) => {
        const count = notifKey ? categoryCounts[notifKey] : 0;
        return (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `relative flex flex-1 flex-col items-center gap-0.5 py-2.5 text-[11px] font-medium ${
                isActive ? "text-primary-600" : "text-slate-500"
              }`
            }
          >
            <span className="relative">
              <Icon className="h-5 w-5" />
              {count > 0 && (
                <span className="absolute -right-1.5 -top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-red-500 text-[8px] font-bold text-white">
                  {count > 9 ? "9+" : count}
                </span>
              )}
            </span>
            {label}
          </NavLink>
        );
      })}
    </nav>
  );
}
